/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShopProductOption } from './ShopProductOption';
import {
  ShopProductOptionFromJSON,
  ShopProductOptionToJSON,
} from './ShopProductOption';

/**
 *
 * @export
 * @interface ShopProduct
 */
export interface ShopProduct {
  /**
   *
   * @type {number}
   * @memberof ShopProduct
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof ShopProduct
   */
  courierId?: number;
  /**
   *
   * @type {string}
   * @memberof ShopProduct
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ShopProduct
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof ShopProduct
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof ShopProduct
   */
  originalPrice?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopProduct
   */
  images?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ShopProduct
   */
  category?: string;
  /**
   *
   * @type {number}
   * @memberof ShopProduct
   */
  categoryId?: number;
  /**
   *
   * @type {boolean}
   * @memberof ShopProduct
   */
  isConfigurable?: boolean;
  /**
   *
   * @type {Array<ShopProductOption>}
   * @memberof ShopProduct
   */
  options?: Array<ShopProductOption>;
  /**
   *
   * @type {string}
   * @memberof ShopProduct
   */
  condition?: string;
  /**
   *
   * @type {number}
   * @memberof ShopProduct
   */
  quantity?: number;
  /**
   *
   * @type {string}
   * @memberof ShopProduct
   */
  status?: string;
  /**
   * URL-friendly slug for SEO
   * @type {string}
   * @memberof ShopProduct
   */
  slug?: string;
  /**
   * Custom meta title for SEO
   * @type {string}
   * @memberof ShopProduct
   */
  metaTitle?: string;
  /**
   * Custom meta description for SEO
   * @type {string}
   * @memberof ShopProduct
   */
  metaDescription?: string;
  /**
   * Comma-separated keywords for SEO
   * @type {string}
   * @memberof ShopProduct
   */
  metaKeywords?: string;
  /**
   * Product brand name
   * @type {string}
   * @memberof ShopProduct
   */
  brand?: string;
  /**
   * Stock keeping unit
   * @type {string}
   * @memberof ShopProduct
   */
  sku?: string;
  /**
   *
   * @type {Date}
   * @memberof ShopProduct
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof ShopProduct
   */
  updatedAt?: Date;
}

/**
 * Check if a given object implements the ShopProduct interface.
 */
export function instanceOfShopProduct(
  value: object
): value is ShopProduct {
  return true;
}

export function ShopProductFromJSON(json: any): ShopProduct {
  return ShopProductFromJSONTyped(json, false);
}

export function ShopProductFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ShopProduct {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    courierId: json['courierId'] == null ? undefined : json['courierId'],
    name: json['name'] == null ? undefined : json['name'],
    description: json['description'] == null ? undefined : json['description'],
    price: json['price'] == null ? undefined : json['price'],
    originalPrice: json['originalPrice'] == null ? undefined : json['originalPrice'],
    images: json['images'] == null ? undefined : json['images'],
    category: json['category'] == null ? undefined : json['category'],
    categoryId: json['categoryId'] == null ? undefined : json['categoryId'],
    isConfigurable: json['isConfigurable'] == null ? undefined : json['isConfigurable'],
    options: json['options'] == null ? undefined : (json['options'] as Array<any>).map(ShopProductOptionFromJSON),
    condition: json['condition'] == null ? undefined : json['condition'],
    quantity: json['quantity'] == null ? undefined : json['quantity'],
    status: json['status'] == null ? undefined : json['status'],
    slug: json['slug'] == null ? undefined : json['slug'],
    metaTitle: json['metaTitle'] == null ? undefined : json['metaTitle'],
    metaDescription: json['metaDescription'] == null ? undefined : json['metaDescription'],
    metaKeywords: json['metaKeywords'] == null ? undefined : json['metaKeywords'],
    brand: json['brand'] == null ? undefined : json['brand'],
    sku: json['sku'] == null ? undefined : json['sku'],
    createdAt: json['createdAt'] == null ? undefined : new Date(json['createdAt']),
    updatedAt: json['updatedAt'] == null ? undefined : new Date(json['updatedAt']),
  };
}

export function ShopProductToJSON(json: any): ShopProduct {
  return ShopProductToJSONTyped(json, false);
}

export function ShopProductToJSONTyped(
  value?: ShopProduct | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    courierId: value['courierId'],
    name: value['name'],
    description: value['description'],
    price: value['price'],
    originalPrice: value['originalPrice'],
    images: value['images'],
    category: value['category'],
    categoryId: value['categoryId'],
    isConfigurable: value['isConfigurable'],
    options: value['options'] == null ? undefined : (value['options'] as Array<any>).map(ShopProductOptionToJSON),
    condition: value['condition'],
    quantity: value['quantity'],
    status: value['status'],
    slug: value['slug'],
    metaTitle: value['metaTitle'],
    metaDescription: value['metaDescription'],
    metaKeywords: value['metaKeywords'],
    brand: value['brand'],
    sku: value['sku'],
    createdAt: value['createdAt'] == null ? undefined : value['createdAt'].toISOString(),
    updatedAt: value['updatedAt'] == null ? undefined : value['updatedAt'].toISOString(),
  };
}
